// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.medical-history-container {
    display: flex;
    padding: 2rem;
    background-color: var(--therapist-bg-color);
    min-height: calc(100vh - 100px);
}
`, "",{"version":3,"sources":["webpack://./app/components/therapist/medical-history/styles/TherapistMedicalHistory.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,2CAA2C;IAC3C,+BAA+B;AACnC","sourcesContent":[".medical-history-container {\n    display: flex;\n    padding: 2rem;\n    background-color: var(--therapist-bg-color);\n    min-height: calc(100vh - 100px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
